import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import { selectDefaultCreationEnvironment } from '../components/pages/environments/environmentsReducer';
import { isNonSalesforceAllowedRoute } from '../constants/nonSalesforceConstants';
import { appRoutes } from '../constants/appRoutes';
import useSweepNavigate from '../navigation-utils/useSweepNavigate';

export const useNonSalesforceRouteGuard = () => {
  const { pathname } = useLocation();
  const { navigate } = useSweepNavigate();
  const defaultCreationEnv = useSelector(selectDefaultCreationEnvironment);
  const isNonSalesforceEnv = Boolean(
    defaultCreationEnv?.orgType && defaultCreationEnv.orgType !== 'salesforce',
  );

  useEffect(() => {
    if (isNonSalesforceEnv && !isNonSalesforceAllowedRoute(pathname)) {
      navigate(appRoutes.getStarted.route, { replace: true });
    }
  }, [isNonSalesforceEnv, pathname, navigate]);
};
